import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import invoiceLogo from "../../../../assets/images/invoicing-icon.svg";
import CommercialAirlineNavigationBar from "../../../../components/element/CommercialAirlineNavigationBar";
import ROUTE_PATHS from "../../../../utils/routePaths";
import InvoicingIATAPaymentRecieptTable from "./Tables/InvoicingIATAPaymentRecieptTable";

function InvoicingIATAPaymentReciept() {
  const [iataInvoicingData, setIATAInvoicingData] = useState(null);

  useEffect(() => {
    const storedData = localStorage.getItem("iataInvoicingData");
    if (storedData) {
      const parsedData = JSON.parse(storedData);
      setIATAInvoicingData(parsedData);
    }
  }, []);

  return (
    <div>
      <div className="invoicing-IATA-container">
        <CommercialAirlineNavigationBar
          title={"Payment Reciept"}
          navigationLogo={invoiceLogo}
          backContent={
            <div className="navigation-header">
              <Link
                to={ROUTE_PATHS.COMMERCIAL_AIRLINE_HOME}
                className="navigation-header-link"
              >
                Home/
              </Link>
              <Link
                to={ROUTE_PATHS.COMMERCIAL_AIRLINE_INVOICING_IATA}
                className="navigation-header-link"
              >
               IATA Invoices/
              </Link>
              Payment Reciept
            </div>
          }
        />
        <div className="invoicing-IATA-table-separator"></div>
        <InvoicingIATAPaymentRecieptTable invoicingData={iataInvoicingData} />
      </div>
    </div>
  );
}

export default InvoicingIATAPaymentReciept;
